import { render } from "./AccountCardsSection.vue?vue&type=template&id=65fa1cd7&scoped=true"
import script from "./AccountCardsSection.vue?vue&type=script&lang=js"
export * from "./AccountCardsSection.vue?vue&type=script&lang=js"

import "./AccountCardsSection.vue?vue&type=style&index=0&id=65fa1cd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fa1cd7"]])

export default __exports__